<script setup lang="ts">
import type { StickerFill, StickerTilt } from './SfgSticker.vue'

withDefaults(defineProps<{
  fill?: StickerFill
  flat?: boolean
  scale?: number | string
  text: string
  tilt?: StickerTilt
}>(), {
  fill: 'chalk',
  flat: false,
  scale: undefined,
  tilt: 2,
})
</script>

<template>
  <SfgSticker
    :fill
    variant="bar"
    :tilt
    :dashed="false"
    size="sm"
    :scale
    :flat
  >
    <div
      class="font-display uppercase"
      style="padding: 6px 12px; letter-spacing: 0.14em; font-size: 13px;"
    >
      {{ text }}
    </div>
  </SfgSticker>
</template>
